export const environment = {
  baseUrl: 'http://localhost:4200',
  production: false,
  api_url: 'https://portal.dev.newmvas.thamdigital.com/api/v1'
  // api_url: 'http://localhost:3000/api/v1'
};
